import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    tripConfig: null,
  },
  getters: {
    getTripConfig(state) {
      return state.tripConfig
    },
  },
  mutations: {
    SET_TRIP_CONFIG_DATA(state, res) {
      state.tripConfig = res
    },
  },
  actions: {
    async fetchTripConfig({ commit }, { service, zone }) {
      const res = await axiosIns.get(`/trips/configurations/${zone}/${service}`)
      commit('SET_TRIP_CONFIG_DATA', res.data.data)
      return res
    },
    async postForm(_, form) {
      await axiosIns.post('/trips/configurations', form)
    },
    async postconCellationResans(_, cofig) {
      await axiosIns.post('/trips/configurations', cofig)
    },
  },
}
